module.exports = __webpack_public_path__ + "static/media/1560444063048-563210410.643f7849.jpg";